"use client";
import styled from "../../../client-utils/styled/index.js";
import { alpha } from "@mui/material/styles";
// import classes
import { listItemButtonClasses } from "@mui/material/ListItemButton";
import { listItemIconClasses } from "@mui/material/ListItemIcon";
import { listItemTextClasses } from "@mui/material/ListItemText";
import { typographyClasses } from "@mui/material/Typography";
import { DOUBLE, TRIPLE, QUINTUPLE, SEXTUPLE } from "../../../constants/numbers.consts.js";
// import components
import ListItemButton from "@mui/material/ListItemButton";
const BACKGROUND_OPACITY = 0.08;
const coreComponentName = "SdbListItemButton";
export const NavigationRailItem = styled(ListItemButton, {
    name: coreComponentName,
    slot: "NavigationRailItem",
})(({ theme }) => ({
    padding: 0,
    marginBottom: theme.spacing(TRIPLE),
    display: "flex",
    flexDirection: "column",
    [`&.${listItemButtonClasses.selected}`]: {
        backgroundColor: "transparent",
        [`.${listItemIconClasses.root}`]: {
            color: theme.vars.palette.common.black,
            backgroundColor: theme.vars.palette.secondary.container,
            ...theme.applyStyles("dark", {
                color: theme.vars.palette.common.white,
            }),
            "&:hover": {
                backgroundColor: alpha(theme.palette.surface.on, BACKGROUND_OPACITY),
                ...theme.applyStyles("dark", {
                    backgroundColor: theme.vars.palette.action.hover,
                }),
            },
        },
        [`.${listItemTextClasses.root} > .${typographyClasses.root}`]: {
            fontWeight: "700",
        },
    },
    [`&.${listItemButtonClasses.selected}:hover`]: {
        backgroundColor: "transparent",
    },
    [`& .${listItemTextClasses.root}`]: {
        color: theme.palette.surface.onVariant,
    },
    [`& .${listItemIconClasses.root}`]: {
        paddingX: theme.spacing(TRIPLE),
        minWidth: "unset",
        color: theme.palette.surface.onVariant,
        backgroundColor: "transparent",
        borderRadius: theme.spacing(QUINTUPLE),
        width: "56px",
        height: "32px",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        transition: theme.transitions.create("background-color"),
    },
    "&:hover": {
        backgroundColor: "transparent",
        [`& .${listItemIconClasses.root}`]: {
            backgroundColor: alpha(theme.palette.surface.on, BACKGROUND_OPACITY),
        },
    },
}));
export const NavigationRailSubItem = styled(ListItemButton, {
    name: coreComponentName,
    slot: "NavigationRailSubItem",
})(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(DOUBLE, SEXTUPLE),
    borderRadius: Number(theme.shape.borderRadius) * DOUBLE,
    [`&.${listItemButtonClasses.selected}`]: {
        [`& .${listItemTextClasses.primary}`]: {
            fontWeight: "700",
        },
    },
}));
